import React from 'react';
import { companyInfo, heroImage } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroImage}
          alt="Construction métallique"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          {/* Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            {companyInfo.tagline}
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-white/80 font-normal mb-10">
            {companyInfo.subtagline}
          </p>

          {/* CTA Button */}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block bg-white text-gray-900 font-medium text-sm px-8 py-3 rounded hover:bg-gray-100 transition-colors duration-200"
          >
            Démarrer un projet
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
